module.exports = __webpack_public_path__ + "img/swiper2.4c39474e.png";